export default __webpack_public_path__ + "static/media/result-fail.1325db52.svg";